
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/in_memory',["require", "exports", '../generic/indexed_filesystem', '../generic/file_index', '../core/buffer', '../generic/preload_file', '../core/util', '../core/browserfs'], function(require, exports, indexed_filesystem, file_index, buffer, preload_file, util, browserfs) {
    var Buffer = buffer.Buffer;
    var NoSyncFile = preload_file.NoSyncFile;

    var InMemory = (function (_super) {
        __extends(InMemory, _super);
        function InMemory() {
            _super.call(this, new file_index.FileIndex());
        }
        InMemory.prototype.empty = function () {
            this._index = new file_index.FileIndex();
        };

        InMemory.prototype.getName = function () {
            return 'In-memory';
        };

        InMemory.isAvailable = function () {
            return true;
        };

        InMemory.prototype.diskSpace = function (path, cb) {
            return cb(Infinity, util.roughSizeOfObject(this._index));
        };

        InMemory.prototype.isReadOnly = function () {
            return false;
        };

        InMemory.prototype.supportsLinks = function () {
            return false;
        };

        InMemory.prototype.supportsProps = function () {
            return false;
        };

        InMemory.prototype._truncate = function (path, flags, stats) {
            stats.size = 0;
            stats.mtime = new Date();
            var file = stats.file_data;
            file._flag = flags;
            file._buffer = new Buffer(0);
            return file;
        };

        InMemory.prototype._fetch = function (path, flags, stats) {
            var file = stats.file_data;
            file._flag = flags;
            return file;
        };

        InMemory.prototype._create = function (path, flags, inode) {
            var stats = inode.getData();
            var file = new NoSyncFile(this, path, flags, stats);
            stats.file_data = file;
            this._index.addPath(path, inode);
            return file;
        };

        InMemory.prototype._rmdirSync = function (path, inode) {
        };
        return InMemory;
    })(indexed_filesystem.IndexedFileSystem);
    exports.InMemory = InMemory;

    browserfs.registerFileSystem('InMemory', InMemory);
});
//# sourceMappingURL=in_memory.js.map
;